// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/CheckSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var CheckSquareOutlined = function CheckSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareOutlinedSvg
  }));
};

CheckSquareOutlined.displayName = 'CheckSquareOutlined';
export default React.forwardRef(CheckSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CheckSquareOutlined.js
// module id = 757
// module chunks = 0